import { workspaceOwnsBilling } from "@helpers/billingOwnership";
import { WorkspaceAction } from "@common/userWorkspaceRoles";
import { useActiveWorkspaceDetails } from "../useActiveWorkspaceDetails";
import { useIsDemoUser } from "../useIsDemoUser";
import { useCanPerformWorkspaceAction } from "./useCanPerformWorkspaceAction";

export function useCanManageWorkspaceBilling() {
    const isDemoUser = useIsDemoUser();
    const activeWorkspaceDetails = useActiveWorkspaceDetails();
    const canManageBilling = useCanPerformWorkspaceAction(
        WorkspaceAction.BILLING_EDIT,
    );

    if (!activeWorkspaceDetails) {
        return false;
    }

    if (isDemoUser) {
        return false;
    }

    // billing is managed at the organization level
    if (!workspaceOwnsBilling(activeWorkspaceDetails)) {
        return false;
    }

    return canManageBilling;
}
